import ProxyBase from '../../ProxyBase';
import ServiceProxyConfig from '../../../../configs/ServiceProxyConfig';

class ValuationProxy extends ProxyBase {
  getValuationTool(data) {
    return this.get('GetValuation', data);
  }
}
const valuationProxy = new ValuationProxy(
  ServiceProxyConfig.Tools.Valuation.ServiceUrl,
);
export default valuationProxy;
